import React from 'react';

interface AuthPanelProps {
  showResetForm: boolean;
  hasResetToken: boolean;
  statusMessage: string;
  statusType: 'success' | 'error';
  resetEmail: string;
  resetPassword: string;
  resetPasswordConfirm: string;
  email: string;
  password: string;
  isSubmittingReset: boolean;
  isSubmittingLogin: boolean;
  onResetEmailChange: (value: string) => void;
  onResetPasswordChange: (value: string) => void;
  onResetPasswordConfirmChange: (value: string) => void;
  onEmailChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onResetFormSubmit: (event: React.FormEvent) => void;
  onLoginFormSubmit: (event: React.FormEvent) => void;
  onShowResetForm: () => void;
  onShowLoginForm: () => void;
}

const AuthPanel: React.FC<AuthPanelProps> = ({
  showResetForm,
  hasResetToken,
  statusMessage,
  statusType,
  resetEmail,
  resetPassword,
  resetPasswordConfirm,
  email,
  password,
  isSubmittingReset,
  isSubmittingLogin,
  onResetEmailChange,
  onResetPasswordChange,
  onResetPasswordConfirmChange,
  onEmailChange,
  onPasswordChange,
  onResetFormSubmit,
  onLoginFormSubmit,
  onShowResetForm,
  onShowLoginForm,
}) => {
  return (
    <main className='login-layout'>
      <section className='login-panel'>
        <p className='eyebrow'>Staff Access</p>
        <p className='subtext'>
          {showResetForm
            ? hasResetToken ? 'Choose a new password for your account.' : 'Enter your email and we will send a secure reset link.'
            : 'Sign in with your staff account to access your dashboard.'}
        </p>

        {statusMessage && <p className={`status ${statusType}`}>{statusMessage}</p>}

        {showResetForm ? (
          <form
            onSubmit={onResetFormSubmit}
            className='reset-form'>
            {!hasResetToken ? <>
              <label htmlFor='reset-email'>Email</label>
              <input id='reset-email' type='email' value={resetEmail} onChange={(e) => onResetEmailChange(e.target.value)} placeholder='admin@restaurant.com' required />
            </> : <>
              <label htmlFor='reset-password'>New Password</label>
              <input id='reset-password' type='password' value={resetPassword} onChange={(e) => onResetPasswordChange(e.target.value)} placeholder='Minimum 8 characters' minLength={8} required />
              <label htmlFor='reset-password-confirm'>Confirm Password</label>
              <input id='reset-password-confirm' type='password' value={resetPasswordConfirm} onChange={(e) => onResetPasswordConfirmChange(e.target.value)} placeholder='Re-enter new password' minLength={8} required />
            </>}

            <button
              type='submit'
              disabled={isSubmittingReset}>
              {isSubmittingReset ? 'Submitting...' : hasResetToken ? 'Reset Password' : 'Send Reset Link'}
            </button>

            <button
              type='button'
              className='reset-toggle'
              onClick={onShowLoginForm}>
              Back to sign in
            </button>
          </form>
        ) : (
          <form
            onSubmit={onLoginFormSubmit}
            className='login-form'>
            <label htmlFor='email'>Email</label>
            <input
              id='email'
              type='email'
              value={email}
              onChange={(e) => onEmailChange(e.target.value)}
              placeholder='name@restaurant.com'
              required
            />

            <label htmlFor='password'>Password</label>
            <input
              id='password'
              type='password'
              value={password}
              onChange={(e) => onPasswordChange(e.target.value)}
              placeholder='********'
              required
            />
<div className='flex flex-col md:flex-row gap-4 mt-4 justify-between items-center'>
            <button className='md:w-6/12 cursor-pointer bg-accentLight text-white px-4 py-2 rounded-full font-semibold hover:bg-accentDark transition-colors duration-300'
              type='submit'
              disabled={isSubmittingLogin}>
              {isSubmittingLogin ? 'Signing in...' : 'Sign In'}
            </button>

            <p className='bg-gray px-3 py-2 cursor-pointer'
              onClick={onShowResetForm}>
              Reset password
            </p>
</div>
          </form>
        )}
      </section>
    </main>
  );
};

export default AuthPanel;
